/* unplugin-vue-components disabled */import { render } from "./privary.vue?vue&type=template&id=37c6f7bf&scoped=true"
import script from "./privary.vue?vue&type=script&lang=js"
export * from "./privary.vue?vue&type=script&lang=js"

import "./privary.vue?vue&type=style&index=0&id=37c6f7bf&lang=less&scoped=true"

import exportComponent from "/Users/hongboyuan/projects/yszn-code/qipaoWeb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37c6f7bf"]])

export default __exports__